import { useState } from "react";

const faqs = [
  {
    question: "Peut-on réparer une crémone ou faut-il systématiquement la changer ?",
    answer: "Dans environ 30% des cas, un nettoyage approfondi, un réalignement des tiges et une lubrification professionnelle suffisent à rétablir le fonctionnement. Si la tige centrale est fendue, un galet écrasé ou un crochet déformé, le remplacement de la crémone complète est nécessaire. Notre technicien diagnostique sur place et vous explique la solution la plus adaptée avant toute intervention."
  },
  {
    question: "Ma fenêtre est bloquée fermée, comment l'ouvrir sans la casser ?",
    answer: "Ne forcez surtout pas la poignée. La solution dépend du type de verrouillage. Si la fenêtre est légèrement entrebâillée, notre technicien peut accéder au dormant par le joint et déverrouiller mécaniquement les points de fermeture. Si elle est complètement fermée, nous démontons le profilé de couverture ou accédons par le cadre pour libérer le mécanisme. Ces manipulations requièrent un outillage spécifique que nous apportons systématiquement."
  },
  {
    question: "Quel est le délai pour remplacer une crémone ?",
    answer: "Un remplacement de crémone standard prend entre 45 minutes et 1h30 selon l'accessibilité du mécanisme et le matériau de la fenêtre. Nous intervenons du lundi au samedi, avec des créneaux le matin et l'après-midi. Pour une fenêtre bloquée fermée en urgence, nous pouvons généralement intervenir sous 24h dans tout le Bas-Rhin, y compris Strasbourg, Schiltigheim, Haguenau et Illkirch."
  },
  {
    question: "Le prix du remplacement de crémone est-il inclus dans le devis gratuit ?",
    answer: "Oui, le diagnostic et le devis sont entièrement gratuits, et le déplacement dans tout le Bas-Rhin est aussi offert. Le prix du remplacement dépend de la marque de la crémone et du matériau de la fenêtre (PVC, aluminium, bois). La pièce neuve et la main-d'œuvre sont comprises dans le devis. Pas de surprise : vous connaissez le montant exact avant que nous commencions l'intervention."
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Questions fréquentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            FAQ — <span className="font-serif italic">Crémone de fenêtre</span>
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-rose-200 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className="font-semibold text-plum text-sm md:text-base pr-4">
                    {faq.question}
                  </span>
                  <div
                    className={`w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0 transition-transform ${
                      openIndex === i ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-plum" />
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-plum-dark text-sm md:text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}